/**
 * @Author: chengzh
 * @Date:   2020-12-02 10:32:43
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-08-23 14:15:02
 */

import { getEnv } from '@/utils/index';
const analytics = function () {
  if (!document.getElementById('analytics-js')) {
    const a = document.createElement('script');
    const pre = 'https://www.googletagmanager.com/gtag/js?id=';
    const env = {
      dev: 'G-JZW70X3VVY',
      // test: 'UA-182253983-1',
      // sandbox: 'UA-182253983-1',
      test: 'G-JZW70X3VVY',
      sandbox: 'G-JZW70X3VVY',
      production: 'UA-182253983-2',
    };

    a.id = 'analytics-js';
    a.defer = !0;
    const c = document.getElementsByTagName('script')[0];
    c.parentNode.insertBefore(a, c);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    let type;

    type = env[getEnv() || 'dev'];

    a.src = pre + type;
    const verDate = new Date();
    window.gtag('js', verDate);
    window.gtag('config', type);
  }
};

module.exports.analytics = analytics;
//
// 生产环境域名：http://gpcashier.lianlianpay.com/
// 测试环境域名：http://gpcashier.lianlianpay-inc.com/
// google分析
// https://analytics.google.com/analytics
// llcelerpay@gmail.com
// llcelerpay@2020
// 15088619814
//
// 测试环境
// <!-- Global site tag (gtag.js) - Google Analytics -->
// <script async src="https://www.googletagmanager.com/gtag/js?id=G-JFT6Q2ERW5"></script>
// <script>
//   window.dataLayer = window.dataLayer || [];
//   function gtag(){dataLayer.push(arguments);}
//   gtag('js', new Date());
//
//   gtag('config', 'G-JFT6Q2ERW5');
// </script>
//
// 正式环境
// <!-- Global site tag (gtag.js) - Google Analytics -->
// <script async src="https://www.googletagmanager.com/gtag/js?id=G-L3WDEBVRYS"></script>
// <script>
//   window.dataLayer = window.dataLayer || [];
//   function gtag(){dataLayer.push(arguments);}
//   gtag('js', new Date());
//
//   gtag('config', 'G-L3WDEBVRYS');
// </script>
//
//
// //todo @埋点 首页 汇款金额输入框点击
// window.gtag('event', '汇款金额输入框点击', {
//   event_category: '首页',
//   event_label: '',
//   value: ''
// });
//
// //todo @埋点 首页 下一步按钮点击
// window.gtag('event', '首页下一步按钮点击', {
//   event_category: '首页',
//   event_label: '进入快速登录页面',
//   value: ''
// });
